












































import AbpBase from "@/lib/abpbase";
import { Component, Prop } from "vue-property-decorator";

@Component
export default class extends AbpBase {
  @Prop({ type: Array, default: [] }) data: any;
  settings: any = [];

  created() {
    if (this.data) {
      this.settings = this.data;
    }
  }
  selectchange(item, index) {
    if (item.valueList) {
      this.settings[index].value = item.valueList.join(",");
    }
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/setting/configuration/parts/settingForm.vue